import SEO from "../components/SEO";
import { motion } from "framer-motion";
import HeroSection from "../components/sections/HeroSection";
import PainPointsSection from "../components/sections/PainPointsSection";
import EmployeeBenefitSection from "../components/sections/EmployeeBenefitSection";
import RoleOverviewSection from "../components/sections/RoleOverviewSection";
import InvestmentSection from "../components/sections/InvestmentSection";
import CareerGrowthSection from "../components/sections/CareerGrowthSection";
import ApplicationForm from "../components/sections/ApplicationForm";
import Footer from "../components/sections/Footer";

const CareersPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-white"
      data-testid="careers-page"
    >
      <HeroSection />
      <PainPointsSection />
      <EmployeeBenefitSection />
      <RoleOverviewSection />
      <InvestmentSection />
      <CareerGrowthSection />
      <ApplicationForm />
      <Footer />
    </motion.div>
  );
};

export default CareersPage;
